import axiosInstance from './config/api';
import {
    WorkflowData,
    PromptsResponse,
    TestGenericQualificationRequest,
    TestGenericQualificationResponse,
} from 'pages/WorkflowBuilder/WorkflowBuilder.types';
import { Workflow } from 'pages/AgenticWorkflow/AgenticWorkflow.types';

export const createAgenticWorkflow = (data: WorkflowData) => {
    return axiosInstance.post<{ id: string }>('/workflows', data).then((res) => res.data);
};

export const getAgenticWorkflows = () => {
    return axiosInstance.get<Workflow[]>('/workflows').then((res) => res.data);
};

export const getEditAgenticWorkflow = (id: string) => {
    return axiosInstance.get<WorkflowData>(`/workflows/edit/${id}`).then((res) => res.data);
};

export const deleteAgenticWorkflow = (id: string) => {
    return axiosInstance.delete(`/workflows/${id}`).then((res) => res.data);
};

export const updateAgenticWorkflow = (id: string, data: WorkflowData) => {
    return axiosInstance.put<{ id: string }>(`/workflows/${id}`, data).then((res) => res.data);
};

export const updateWorkflowStatus = (id: string) => {
    return axiosInstance.put(`/workflows/status/${id}`).then((res) => res.data);
};

export const getWorkflowTranscript = (callId: string) => {
    return axiosInstance.get(`/workflows/transcripts/${callId}`).then((res) => res.data);
};

export const getWorkflowAudio = (callId: string) => {
    return axiosInstance
        .get(`/workflows/audio/${callId}`, {
            responseType: 'arraybuffer',
        })
        .then((res) => res.data)
        .then((data) => new Blob([data], { type: 'audio/ogg' }));
};

export const getPrompts = () => {
    return axiosInstance.get<PromptsResponse>('/workflows/node-configs').then((res) => res.data);
};

export const deleteCalls = (callIds: string[]) => {
    return axiosInstance.delete('/workflows/calls', { data: { callIds } }).then((res) => res.data);
};

export const deleteSMS = (smsIds: string[]) => {
    return axiosInstance.delete('/sms', { data: { smsIds } }).then((res) => res.data);
};

export const postTestGenericQualification = ({ transcript, config }: TestGenericQualificationRequest) => {
    return axiosInstance
        .post<TestGenericQualificationResponse>('/workflows/test/generic-qualification', { transcript, config })
        .then((res) => res.data);
};
